import React from 'react';
import '../styles/pages/FacebookTikTokAds.css';

const FacebookTikTokAds = () => {
  return (
    <div className="facebook-tiktok-ads-page">
      <div className="container">
        <header className="page-header">
          <h1>Oferta Usług Reklamowych Facebook i TikTok Ads dla Firm Finansowych</h1>
          <p>Skuteczne kampanie reklamowe, które pomogą Twojej firmie finansowej pozyskać nowych klientów</p>
        </header>

        <div className="info-box">
          <p><strong>Dlaczego warto inwestować w reklamy na Facebooku i TikToku dla usług finansowych?</strong></p>
          <p>Media społecznościowe są idealnym miejscem do budowania świadomości marki i pozyskiwania klientów zainteresowanych usługami finansowymi. Nasze kampanie pozwalają:</p>
          <ul className="icon-list">
            <li>Precyzyjnie docierać do osób potencjalnie zainteresowanych kredytami, pożyczkami i doradztwem finansowym</li>
            <li>Budować zaufanie do Twojej marki poprzez profesjonalny i spójny przekaz</li>
            <li>Edukować odbiorców o Twoich usługach i ich zaletach</li>
            <li>Generować wysokiej jakości leady i obniżać koszt pozyskania klienta</li>
            <li>Śledzić efekty i stale optymalizować kampanie dla lepszych wyników</li>
          </ul>
        </div>

        <h2>Platformy reklamowe</h2>
        
        <div className="platform-highlight">
          <div className="platform-card fb">
            <div className="platform-icon">F</div>
            <h3 className="platform-title">Facebook Ads</h3>
            <p>Facebook to największa platforma społecznościowa na świecie, z ponad 2,9 miliarda aktywnych użytkowników. Dla firm finansowych, jest to idealne narzędzie, które pozwala:</p>
            <ul>
              <li>Dotrzeć do szerokiej grupy demograficznej, w tym osób w wieku 30-65 lat - głównej grupy docelowej usług finansowych</li>
              <li>Wykorzystać zaawansowane opcje targetowania oparte na zachowaniach, zainteresowaniach i danych demograficznych</li>
              <li>Reklamować się w formie postów, relacji, wideo i reklam karuzelowych</li>
              <li>Kierować ruch bezpośrednio na stronę internetową lub formularz kontaktowy</li>
            </ul>
          </div>
          
          <div className="platform-card tiktok">
            <div className="platform-icon">T</div>
            <h3 className="platform-title">TikTok Ads</h3>
            <p>TikTok to dynamicznie rozwijająca się platforma, popularna szczególnie wśród młodszych użytkowników. Dla firm finansowych, TikTok oferuje:</p>
            <ul>
              <li>Dostęp do młodszych odbiorców (18-35 lat) - idealnych dla ofert pierwszych kredytów, kont oszczędnościowych czy ubezpieczeń</li>
              <li>Możliwość kreatywnego przedstawienia usług finansowych w przystępny i angażujący sposób</li>
              <li>Szybkie budowanie świadomości marki dzięki wiralowemu potencjałowi platformy</li>
              <li>Mniejszą konkurencję w sektorze finansowym niż na innych platformach</li>
            </ul>
          </div>
        </div>

        <h2>Nasze pakiety Facebook lub TikTok Ads</h2>
        
        <div className="packages">
          <div className="package-card">
            <div className="package-header">
              <div className="package-name">Pakiet Podstawowy</div>
              <div className="package-price">500 zł <span className="package-price-note">/ miesiąc</span></div>
              <div className="budget-info">Sugerowany budżet reklamowy: od 1000 zł</div>
            </div>
            
            <ul>
              <li>Opłata początkowa: 100 zł (jednorazowo w pierwszym miesiącu)</li>
              <li>Obsługa do 2 kampanii jednocześnie</li>
              <li>Czas pracy specjalisty: 3h/miesiąc</li>
              <li>2 projekty graficzne miesięcznie</li>
              <li>Raport efektywności raz w miesiącu</li>
              <li>Podstawowe targetowanie demograficzne i behawioralne</li>
              <li>Konfiguracja Pixela Facebook na stronie</li>
              <li>Podstawowa optymalizacja kampanii</li>
            </ul>
          </div>
          
          <div className="package-card recommended">
            <span className="recommended-badge">Rekomendowany</span>
            <div className="package-header">
              <div className="package-name">Pakiet Standardowy</div>
              <div className="package-price">1 200 zł <span className="package-price-note">/ miesiąc</span></div>
              <div className="budget-info">Sugerowany budżet reklamowy: od 5 000 zł</div>
            </div>
            
            <ul>
              <li>Opłata początkowa: 200 zł (jednorazowo w pierwszym miesiącu)</li>
              <li>Obsługa do 5 kampanii jednocześnie</li>
              <li>Czas pracy specjalisty: 7h/miesiąc</li>
              <li>5 projektów graficznych miesięcznie</li>
              <li>Podstawowy montaż dostarczonych materiałów wideo</li>
              <li>Raport efektywności 2 razy w miesiącu</li>
              <li>Zaawansowane targetowanie i segmentacja odbiorców</li>
              <li>Kampanie pod różne produkty finansowe</li>
              <li>A/B testy kreacji reklamowych</li>
              <li>Optymalizacja konwersji i kosztów pozyskania klienta</li>
            </ul>
          </div>
          
          <div className="package-card">
            <div className="package-header">
              <div className="package-name">Pakiet Premium</div>
              <div className="package-price">od 2 100 zł <span className="package-price-note">/ miesiąc</span></div>
              <div className="budget-info">Sugerowany budżet reklamowy: od 12 000 zł</div>
            </div>
            
            <ul>
              <li>Opłata początkowa: 300 zł (jednorazowo w pierwszym miesiącu)</li>
              <li>Indywidualna liczba kampanii</li>
              <li>Czas pracy specjalisty: 13h/miesiąc</li>
              <li>Nieograniczona liczba projektów graficznych</li>
              <li>Montaż dostarczonych materiałów wideo</li>
              <li>Indywidualne produkcje wideo</li>
              <li>Raport efektywności 4 razy w miesiącu (co tydzień)</li>
              <li>Zaawansowane strategie remarketingowe</li>
              <li>Pełne wsparcie w generowaniu i obsłudze leadów</li>
              <li>Indywidualna strategia komunikacji</li>
              <li>Dedykowane kreacje pod każdy produkt finansowy</li>
            </ul>
          </div>
        </div>
        
        <h2>Porównanie pakietów</h2>
        
        <div className="table-container">
          <table className="features-table">
            <thead>
              <tr>
                <th>Funkcjonalność</th>
                <th>Pakiet Podstawowy</th>
                <th>Pakiet Standardowy</th>
                <th>Pakiet Premium</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="feature-name">Cena miesięczna</td>
                <td>500 zł</td>
                <td>1 200 zł</td>
                <td>od 2 100 zł</td>
              </tr>
              <tr>
                <td className="feature-name">Opłata początkowa</td>
                <td>100 zł</td>
                <td>200 zł</td>
                <td>300 zł</td>
              </tr>
              <tr>
                <td className="feature-name">Sugerowany budżet reklamowy</td>
                <td>od 1 000 zł</td>
                <td>od 5 000 zł</td>
                <td>od 12 000 zł</td>
              </tr>
              <tr>
                <td className="feature-name">Liczba kampanii</td>
                <td>do 2</td>
                <td>do 5</td>
                <td>bez limitu</td>
              </tr>
              <tr>
                <td className="feature-name">Czas pracy specjalisty</td>
                <td>3h/mies.</td>
                <td>7h/mies.</td>
                <td>13h/mies.</td>
              </tr>
              <tr>
                <td className="feature-name">Projekty graficzne</td>
                <td>2 miesięcznie</td>
                <td>5 miesięcznie</td>
                <td>bez limitu</td>
              </tr>
              <tr>
                <td className="feature-name">Materiały wideo</td>
                <td>brak</td>
                <td>podstawowy montaż</td>
                <td>montaż + produkcje</td>
              </tr>
              <tr>
                <td className="feature-name">Raportowanie</td>
                <td>1x / miesiąc</td>
                <td>2x / miesiąc</td>
                <td>4x / miesiąc</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <h2>Proces współpracy</h2>
        
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Analiza i strategia</h3>
              <p>Poznajemy Twoją firmę, cele biznesowe i określamy strategię reklamową</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Przygotowanie kampanii</h3>
              <p>Tworzymy grupy odbiorców, kreacje reklamowe i ustawiamy kampanie</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Uruchomienie i monitorowanie</h3>
              <p>Uruchamiamy kampanie i na bieżąco monitorujemy ich skuteczność</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Optymalizacja</h3>
              <p>Stale optymalizujemy kampanie w oparciu o zbierane dane</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">5</div>
            <div className="step-content">
              <h3>Raportowanie</h3>
              <p>Regularnie dostarczamy raporty z efektów kampanii</p>
            </div>
          </div>
        </div>
        
        <h2>Warunki współpracy</h2>
        
        <div className="info-box">
          <ul>
            <li><strong>Minimalny okres współpracy:</strong> 3 miesiące</li>
            <li><strong>Rozliczenie:</strong> Płatność miesięczna za obsługę kampanii + opłata początkowa (jednorazowo)</li>
            <li><strong>Budżet reklamowy:</strong> Opłacany bezpośrednio na koncie reklamowym klienta</li>
            <li><strong>Start kampanii:</strong> Do 7 dni roboczych od podpisania umowy i dostarczenia materiałów</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FacebookTikTokAds;